export default __webpack_public_path__ + "static/media/Break.608579ca.svg";